import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
// import { styled } from '@mui/material/styles';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { sendLogin } from '../../auth/Auth';
import { acceptBooking } from '../../actions/Booking';
import ValidationText from '../atoms/ValidationText';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '330px',
    height: 'auto',
    maxHeight: '80%',
    top: '50%',
    left: '49%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    padding: 15,
    overflow: 'hidden',
    outline: 'none',
    fontSize: 12,
    lineHeight: '16px',
    color: '#333333',
    borderRadius: 4
  },
  title: {
    background: 'ffffff',
    color: '#000000',
    margin: '10px -15px 0px -15px',
    padding: '15px',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: '600'
  },
  textFieldLong: {
    width: '100%',
    borderColor: '#DDDDDD',
    backgroundColor: '#F0F0F0'
  },
  row: {
    display: 'flex',
    width: '100%',
    marginBottom: '-1px'
  },
  titleContent: {
    lineHeight: '28px',
    paddingTop: 8,
    width: '100%',
    color: '#646464',
    fontSize: '16px',
    borderTop: '0.5px solid #DDDDDD'
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  btnCloseDiv: {
    textAlign: 'center'
  },
  btnClose: {
    fontSize: 14,
    marginTop: '10px',
    backgroundColor: '#F44A4A',
    '&:disabled': {
      color: '#fff',
      backgroundColor: '#f37575'
    },
    '&:hover': {
      color: '#fff',
      backgroundColor: '#f37575'
    }
  },
  btnx: {
    position: 'absolute',
    top: '12px',
    right: '6px',
    minWidth: '12px',
    color: '#000000'
  },
  iconButton: {
    width: '12px',
    height: '12px'
  },
  dataContent: {
    paddingTop: '13px'
  },
  input: {
    lineHeight: '28px',
    marginBottom: '5px',
    width: '100px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators({ acceptBooking }, dispatch)
    })
  ),
  setPropTypes(propTypes),

  // withState('checkSubmit', 'setCheckSubmit', true),
  withState('inputAmountError', 'setInputAmountError', ''),
  withState('inputData', 'setInputData', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    setOpenAcceptPopup,
    inputData,
    actions,
    setDataAccept,
    setInputData,
    checkSession,
    setInputAmountError,
    handleChangePage,
    // checkSubmit,
    checkShop,
    // setCheckSubmit,
    inputAmountError
  }) => {
    const closeAction = () => {
      setOpenAcceptPopup(false);
    };

    const validInput = value => {
      if (!value) {
        setInputAmountError('お客様にメッセージをご記入ください');
        return 1;
      }
      if (value && value.length > 200) {
        setInputAmountError('200字以内ご入力してください');
        return 1;
      }
      setInputAmountError('');
      return 0;
    };

    const params = {
      status: 'FINISHED',
      bookingMessage: inputData
    };

    const callAPI = async () => {
      if (validInput(inputData) === 1) {
        return;
      }
      await actions
        .acceptBooking(setDataAccept, params)
        .then(data => {
          checkSession(data);

          if (data.type === 'EDIT_STATUS_BOOKING_SUCCESS') {
            if (checkShop) {
              handleChangePage(1);
            } else {
              handleChangePage(null, 1, 100);
            }
            setOpenAcceptPopup(false);
          } else {
            // TODO: show failed message
            setOpenAcceptPopup(false);
          }
        })
        .catch(() => {
          // TODO: show failed message
          setOpenAcceptPopup(false);
        });
    };

    return (
      <div className={classes.root}>
        <Button className={classes.btnx} onClick={closeAction} color="primary">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.svg`}
            alt="close"
            className={classes.iconButton}
          />
        </Button>
        <div className={classes.title}>お客様に連絡する</div>
        <div className={classes.titleContent}>
          お客様にメッセージを送信します。
        </div>
        <div className={classes.row}>
          <div style={{ width: '100%' }}>
            <Typography className={classes.formInput}>
              <TextField
                placeholder="お客様にメッセージをご記入ください"
                multiline
                id="outlined-basic"
                variant="outlined"
                rows="8"
                style={{ width: '100%', fontSize: '14px' }}
                className={classes.textFieldLong}
                margin="normal"
                inputProps={{
                  maxLength: 200
                }}
                value={inputData}
                onBlur={event => validInput(event.target.value)}
                onChange={e => {
                  setInputData(e.target.value);
                }}
              />
            </Typography>
            <ValidationText message={inputAmountError} />
          </div>
        </div>

        <div className={classes.btnCloseDiv}>
          <Button
            color="primary"
            variant="contained"
            onClick={callAPI}
            // disabled={checkSubmit}
            className={classes.btnClose}
          >
            送信する
          </Button>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
